module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_1000_5000.9677deb3.png";